module.exports = __webpack_public_path__ + "static/media/floorplan_draw2.32a70fda.png";